'use strict';

var router,
    initialState,
    currentState;

module.exports = {
  isInitialPath() {
    return currentState === initialState;
  },

  getCurrentPath() {
    return router.getCurrentPath();
  },

  makePath(to, params, query) {
    return router.makePath(to, params, query);
  },

  makeHref(to, params, query) {
    return router.makeHref(to, params, query);
  },

  transitionTo(to, params, query) {
    router.transitionTo(to, params, query);
  },

  replaceWith(to, params, query) {
    router.replaceWith(to, params, query);
  },

  goBack() {
    router.goBack();
  },

  run(render) {
    router.run((Handler, state) => {
      if (!currentState) {
        initialState = state;
      }

      currentState = state;
      render(Handler, state);
    });
  }
};

var routes = require('./routes'),
    Router = require('react-router');

router = Router.create({
  routes: routes,
  location: Router.HistoryLocation
});

if (module.hot) {
  module.hot.accept('./routes', function () {
    routes = require('./routes');
    router.replaceRoutes(routes);
  });
}


/** WEBPACK FOOTER **
 ** ./router.js
 **/